<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks'

    export default {
        components: {
            AppTabLinks
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Сторисы',
                        url: '/stories'
                    },
                    {
                        title: 'Настройки',
                        url: '/stories/settings'
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    }
</script>
